import { useState } from 'react'

import { ParticipantForgetPwd } from './ForgetPassword'
import { ParticipantLogin } from './Login'
import { ParticipantResetPwd } from './ResetPassword'

enum ScreenType {
  Login,
  ForgetPassword,
  ResetPassword,
}

/**
 * Investor portal sign-in. An investor whose password is still the generated one
 * (`requireReset`) is sent straight to Create Password before the portal opens, the same way the
 * investor portal does it.
 */
export function ParticipantAuth({ token, onSigned: _onSigned }: { token: string; onSigned: Function }) {
  const [screenType, setScreenType] = useState<ScreenType>(ScreenType.Login)
  const [newToken, setNewToken] = useState('')

  const onSigned = (token: string, isRequireResetPwd: boolean) => {
    if (!isRequireResetPwd) {
      _onSigned(token)
      return
    }
    setNewToken(token)
    setScreenType(ScreenType.ResetPassword)
  }

  if (screenType == ScreenType.Login)
    return (
      <ParticipantLogin
        token={token}
        onSigned={onSigned}
        onForgotPwd={() => setScreenType(ScreenType.ForgetPassword)}
      />
    )

  if (screenType == ScreenType.ResetPassword)
    return <ParticipantResetPwd token={newToken} onSubmit={() => _onSigned(newToken)} />

  return <ParticipantForgetPwd token={token} onSubmit={() => setScreenType(ScreenType.Login)} />
}
